const SANDBOX_CAMPAIGN_PREVIEW_PREFIX = "campaign_preview-";
const SANDBOX_CAMPAIGN_PREFIX = "campaign-";
const DEFAULT_CONTAINER = "production";
export default {
    getPreviewByCampaignId(campaignId) {
        return SANDBOX_CAMPAIGN_PREVIEW_PREFIX + campaignId;
    },
    getPreviewByCampaignIdWithJourneyName(campaignId, journeyName) {
        return SANDBOX_CAMPAIGN_PREVIEW_PREFIX + campaignId + "-" + journeyName;
    },
    getReferralByCampaignId(campaignId, container) {
        return `${SANDBOX_CAMPAIGN_PREFIX + campaignId}-${container || DEFAULT_CONTAINER}`;
    },
};
